(ns app.front.ui.top-bar
  (:require [app.front.util :as futil]
            [app.front.view.navigation :as nav]
            [core.front.href :as href]
            [core.util.util :as util]
            [potpuri.core :as p]))

(defn env-name []
  (futil/get-meta-content-by-name "vaahteraEnv"))

(def env-alert-envs
  #{"training"
    "sandbox"
    "agent-sandbox"
    "local"})

(defn back-to-dashboard [tr]
  [nav/responsive-back-to-button
   (href/href :dashboard)
   (tr [:back])
   (tr [:back-to-dashboard])
   "return-to-dashboard-button"])

(defn generic-top-bar [{:keys [tr match]} back-to & [actions & more-rows]]
  (into
    [:div.w-full.border-b.border-solid.border-gray-200.bg-ui-white
     [:div.flex.flex-row.justify-between.items-center.top-bar.pr-4
      [:div.flex-row.flex.items-center.divide-x.divide-gray-300.divide-solid
       [:div.pr-2.pl-1 back-to]
       [:div.hidden.md:block
        [nav/breadcrumb (util/mmap {:class-name "pl-2"}
                                   tr match)]]]
      actions]]
    more-rows))

(def default-bg
  "bg-ui-blue border-ui-blue text-ui-white")

(def severity->bg
  {:low    default-bg
   :medium "bg-ui-yellow border-ui-yellow"
   :high   "bg-ui-yellow border-ui-red"})

(defn alert-banner [{:keys [id severity]} content]
  [:div.p-2.border-solid.border-2.flex.justify-around.sticky.top-0
   (p/assoc-if {:class ["z-[8999]" (severity->bg severity default-bg)]}
               :id id)
   [:h4.uppercase.overflow-ellipsis.overflow-hidden.whitespace-nowrap
    content]])

(defn environment-banner [tr env]
  (if (= env "local")
    [alert-banner {:id       "environment-banner"
                   :severity :low}
     (tr [:environment-alert-local])]
    [alert-banner {:id       "environment-banner"
                   :severity :high}
     (tr [:environment-alert-test])]))
